import { Http } from '@/services/http';
import { store } from '@/stores';
import { baseStates, baseMutations, baseActions, baseGetters } from '@/stores/base';

const loadUrl = '/my-account';

export const myAccount = {

    namespaced: true,

    state:
    {
        ...baseStates,

        url: loadUrl,
    },

    mutations:
    {
        ...baseMutations,
    },

    actions:
    {
        ...baseActions,

        customUpdate: async ({ commit }, { url, form }) =>
        {
            commit('setLoading', { action: 'update', boolean: true });

            const response = await Http.put(url, form);
            
            commit('setLoading', { action: 'update', boolean: false });

            if (response.status === 200) store.dispatch('auth/updateUser', response.data);

            return response;
        },

        updatePhoto: async ({ commit }, form) =>
        {
            commit('setLoading', { action: 'update', boolean: true });

            const response = await Http.put(`${loadUrl}/photo`, form);
            
            commit('setLoading', { action: 'update', boolean: false });

            if (response.status === 200) store.dispatch('auth/updateUser', response.data);

            return response;
        },

        updateAccount: async ({ commit }, form) =>
        {
            commit('setLoading', { action: 'update', boolean: true });

            const response = await Http.put(`${loadUrl}`, form);
            
            commit('setLoading', { action: 'update', boolean: false });

            if (response.status === 200) store.dispatch('auth/updateUser', response.data);

            return response;
        },

        updateUsername: async ({ commit }, form) =>
        {
            commit('setLoading', { action: 'update', boolean: true });

            const response = await Http.put(`${loadUrl}/username`, form);
            
            commit('setLoading', { action: 'update', boolean: false });

            if (response.status === 200) store.dispatch('auth/updateUser', response.data);

            return response;
        },

        updatePassword: async ({ commit }, form) =>
        {
            commit('setLoading', { action: 'update', boolean: true });

            const response = await Http.put(`${loadUrl}/password`, form);
            
            commit('setLoading', { action: 'update', boolean: false });

            if (response.status === 200) store.dispatch('auth/updateUser', response.data);

            return response;
        },
    },

    getters:
    {
        ...baseGetters,
    },
};



// WEBPACK FOOTER //
// ./src/views/my-account/store.js